/* tslint:disable:max-line-length */
import { FuseNavigationItem } from "@fuse/components/navigation";

export const adminNavigation: FuseNavigationItem[] = [
  {
    id: 'expert-program',
    title: 'Expert Program',
    subtitle: '회원 관리',
    type: 'group',
    icon: 'mat_outline:description',
    children: [
      {
        id: 'expert-program.expert-program',
        title: '회원 관리',
        type: 'basic',
        icon: 'heroicons_solid:user-group',
        link: '/expert-program',
      },
      {
        id: 'expert-program.expert-program-schedule',
        title: '일정',
        type: 'basic',
        icon: 'mat_outline:fitness_center',
        link: '/expert-program-schedule',
      },
    ],
  },
  {
    id: 'settings',
    title: 'Settings',
    subtitle: '계정 관련 설정',
    type: 'group',
    icon: 'mat_outline:settings',
    children: [
      {
        id: 'settings.settings',
        title: '설정',
        type: 'basic',
        icon: 'mat_outline:settings',
        link: '/settings',
      },
    ],
  },
];

export const expertManagerNavigation: FuseNavigationItem[] = [
  {
    id: 'expert-console',
    title: 'Expert Console',
    subtitle: '홈',
    type: 'group',
    icon: 'mat_outline:description',
    children: [
      {
        id: 'expert-console.expert-console',
        title: '홈',
        type: 'basic',
        icon: 'heroicons_solid:user-group',
        link: '/welcome',
      },
    ],
  },
  {
    id: 'settings',
    title: 'Settings',
    subtitle: '계정 관련 세팅',
    type: 'group',
    icon: 'mat_outline:settings',
    children: [
      {
        id: 'settings.settings',
        title: '설정',
        type: 'basic',
        icon: 'mat_outline:settings',
        link: '/settings',
      },
    ],
  },
];

export const compactNavigation: FuseNavigationItem[] = [
  {
    id: 'expert-program',
    title: 'Expert Program',
    subtitle: '회원 관리',
    type: 'group',
    icon: 'mat_outline:description',
    children: [
      {
        id: 'expert-program.expert-program',
        title: '회원 관리',
        type: 'basic',
        icon: 'heroicons_solid:user-group',
        link: '/expert-program',
      },
      {
        id: 'expert-program.expert-program-schedule',
        title: '일정',
        type: 'basic',
        icon: 'mat_outline:fitness_center',
        link: '/expert-program-schedule',
      },
    ],
  },
  {
    id: 'settings',
    title: 'Settings',
    subtitle: '계정 관련 세팅',
    type: 'group',
    icon: 'mat_outline:settings',
    children: [
      {
        id: 'settings.settings',
        title: '설정',
        type: 'basic',
        icon: 'mat_outline:settings',
        link: '/settings',
      },
    ],
  },
];
export const futuristicNavigation: FuseNavigationItem[] = [
  {
    id: 'expert-program',
    title: 'Expert Program',
    subtitle: '회원 관리',
    type: 'group',
    icon: 'mat_outline:description',
    children: [
      {
        id: 'expert-program.expert-program',
        title: '회원 관리',
        type: 'basic',
        icon: 'heroicons_solid:user-group',
        link: '/expert-program',
      },
      {
        id: 'expert-program.expert-program-schedule',
        title: '일정',
        type: 'basic',
        icon: 'mat_outline:fitness_center',
        link: '/expert-program-schedule',
      },
    ],
  },
  {
    id: 'settings',
    title: 'Settings',
    subtitle: '계정 관련 세팅',
    type: 'group',
    icon: 'mat_outline:settings',
    children: [
      {
        id: 'settings.settings',
        title: '설정',
        type: 'basic',
        icon: 'mat_outline:settings',
        link: '/settings',
      },
    ],
  },
];
export const horizontalNavigation: FuseNavigationItem[] = [
  {
    id: 'expert-console.expert-console',
    title: '홈',
    type: 'basic',
    icon: 'heroicons_solid:user-group',
    link: '/expert-console-list',
  },
  {
    id: 'settings.settings',
    title: '설정',
    type: 'basic',
    icon: 'mat_outline:settings',
    link: '/settings',
  },
];
